











import mixins from 'vue-typed-mixins';
import HumanResourcesTable from '../HumanResourcesTable.vue';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    HumanResourcesTable,
  },
  props: {
    question: {
      type: Object as () => Question,
    },
  },
  computed: {
    headers(): any[] {
      return [
        ...this.$attrs.headers,
        {
          text: this.$translate(this.question.options.language.total),
          value: 'positioncount.total',
        },
        {
          text: this.$translate(this.question.options.language.nondbp),
          value: 'positioncount.nondbp',
        },
      ];
    },
  },
  methods: {
    displayNumber(value: any) {
      return parseFloat(value || 0)?.toFixed(2);
    },
  },
});
